interface AddressFields {
  street?: string | null
  streetNumber?: string | null
  streetNo?: string | null
}

export const formatAddress = (address: AddressFields | undefined | null): string => {
  if (!address) return 'Saknar adress'

  const streetNo = address.streetNumber ?? address.streetNo
  if (address.street) {
    return streetNo ? `${address.street} ${streetNo}` : address.street
  }

  return 'Saknar adress'
}
